import React, { useEffect, useState } from "react";
import { Button, Container, Form } from "react-bootstrap";
import { IoHomeOutline } from "react-icons/io5";
import { AllUsers, GetAllManagerUsers } from "../../utils/proxy/Authproxy";
import Select from "react-select";
import { Op_per } from "../../utils/Permissions";
import { RiFileExcel2Fill } from "react-icons/ri";
import { GetCampignReport } from "../../utils/proxy/ChartsProxy";
import LoadingComponent from "../Includes/LoadingComponent";

const CampignReport = () => {
      const [data, setData] = useState([]);
      const [userid, setUserId] = useState(localStorage.getItem('role') === 'User' ? localStorage.getItem('uuid') : null);
      const [selectedUser, setSelectedUser] = useState();
      const [selectedType, setSelectedType] = useState({ value: 'doctor', label: 'Doctor' });
      const [type, setType] = useState('doctor');
      const [productType, setProductType] = useState(true);
      const [users, setUsers] = useState([]);
      const [start, setStart] = useState();
      const [end, setEnd] = useState();
      const [reload, setReload] = useState(false);
      const [pending, setPending] = useState(false);
  
      useEffect(() => {
          // Fetch data from an API when the component mounts
          const getallusers = async () => {
              if (localStorage.getItem('role') === 'Admin') {
                  let allusers = await AllUsers();
                  allusers.push({ firstname: localStorage.getItem('firstname'), lastname: localStorage.getItem('lastname'), userid: localStorage.getItem('uuid'), username: localStorage.getItem('username') })
                  setUsers(allusers);
              } else if (localStorage.getItem('role') === 'Manager') {
                  let allusers = await GetAllManagerUsers(localStorage.getItem('uuid'));
                  setUsers(allusers);
              }
          };
          getallusers();
      }, []);


  
    useEffect(() => {
    const getallteritories = async (userid, from, to, type,isTrue) => {
        let userteritories = await GetCampignReport(
            userid,
            from,
            to,
            type,
            isTrue
        );

        if (userteritories) {
            setData(userteritories);
            setPending(false);
        } else {
            alert("Error", "Issue While Fetching Tour Plan");
        }
    };
    if (userid && start && end && (productType === true || productType === false)) {
        setPending(true);
        getallteritories(userid, start, end, type, productType);
    }
    setReload(false);
}, [reload, userid, start, end, type, productType]);

  
      const handleSelectChange = (selected) => {
  
          setUserId(selected.value);
          setSelectedUser(selected);
      };
             

      const productTypeOptions = [
  { value: true, label: "Product" },
  { value: false, label: "Gift" },
];
  
      const handleTypeChange = (selected) => {
          setSelectedType(selected);
          setType(selected.value);
      }


    const options = [];
    const typeoptions = [
        { value: 'doctor', label: 'Doctor' },
        { value: 'cip', label: 'CIP' },
    ];

    users.map((user) => {
        options.push({
            value: user.userid,
            label: user.username + "(" + user.firstname + " " + user.lastname + ")",
            name: user.username
        });
    });

// function downloadCSV(data, selectedType, selectedUser = { name: "User" }) {
//   if (!data || data.length === 0) {
//     alert("No data to export.");
//     return;
//   }

//   const rows = [];

//   if (selectedType.value === 'cip') {
//     // Header row for CIP
//     rows.push([
//       "CIP Name",
//       "Hospital Name",
//       "Territory",
//       "Department",
//       "Designation",
//       "Month",
//       "Product Name",
//       "Quantity"
//     ]);

//     data.forEach(cip => {
//       const allProducts = cip.campignDoctorInners.flatMap(monthObj =>
//         monthObj.productDetails
//           .filter(p => p.productName && p.quantity > 0)
//           .map(product => ({
//             month: monthObj.month,
//             productName: product.productName,
//             quantity: product.quantity,
//           }))
//       );

//       if (allProducts.length === 0) {
//         // No products - export just CIP info with empty product fields
//         rows.push([
//           cip.cipName,
//           cip.hospitalName,
//           cip.teritory,
//           cip.department,
//           cip.designation || "N/A",
//           "",
//           "No products",
//           ""
//         ]);
//       } else {
//         allProducts.forEach(prod => {
//           rows.push([
//             cip.cipName,
//             cip.hospitalName,
//             cip.teritory,
//             cip.department,
//             cip.designation || "N/A",
//             prod.month,
//             prod.productName,
//             prod.quantity
//           ]);
//         });
//         // Add total quantity row
//         const grandTotalQuantity = allProducts.reduce((sum, p) => sum + p.quantity, 0);
//         rows.push([
//           "", "", "", "", "", "", "Total Quantity:", grandTotalQuantity
//         ]);
//       }
//     });

//   } else if (selectedType.value === 'doctor') {
//     // Header row for Doctor
//     rows.push([
//       "Doctor Name",
//       "Hospital Name",
//       "Clinic Name",
//       "Specialization",
//       "Month",
//       "Product Name",
//       "Quantity"
//     ]);

//     data.forEach(doctor => {
//       const allProducts = doctor.campignDoctorInners.flatMap(monthObj =>
//         monthObj.productDetails
//           .filter(p => p.productName && p.quantity > 0)
//           .map(product => ({
//             month: monthObj.month,
//             productName: product.productName,
//             quantity: product.quantity,
//           }))
//       );

//       if (allProducts.length === 0) {
//         // No products - export just doctor info with "No products"
//         rows.push([
//           doctor.doctorName,
//           doctor.hospitalName,
//           doctor.clinicName || "N/A",
//           doctor.specialization,
//           "",
//           "No products",
//           ""
//         ]);
//       } else {
//         allProducts.forEach(prod => {
//           rows.push([
//             doctor.doctorName,
//             doctor.hospitalName,
//             doctor.clinicName || "N/A",
//             doctor.specialization,
//             prod.month,
//             prod.productName,
//             prod.quantity
//           ]);
//         });
//         // Add total quantity row
//         const grandTotalQuantity = allProducts.reduce((sum, p) => sum + p.quantity, 0);
//         rows.push([
//           "", "", "", "", "", "Total Quantity:", grandTotalQuantity
//         ]);
//       }
//     });

//   } else {
//     alert("Invalid selected type for export.");
//     return;
//   }

//   // Convert rows to CSV string with escaping
//   const csv = rows
//     .map(row =>
//       row
//         .map(field => {
//           const value = field == null ? "" : String(field);
//           return /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
//         })
//         .join(",")
//     )
//     .join("\n");

//   // Compose filename
//   const filename = `${selectedType.value.toUpperCase()}ProductDetails(${selectedUser.name})-${new Date().toISOString().slice(0, 10)}.csv`;

//   // Trigger download
//   const csvData = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
//   const link = document.createElement("a");
//   link.setAttribute("href", csvData);
//   link.setAttribute("download", filename);
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }
function downloadCSV(data, selectedType, selectedUser = { name: "User" }) {
  if (!selectedType || !selectedType.value) {
    alert("Please select a valid type before exporting.");
    return;
  }

  const rows = [];

  if (selectedType.value === "cip") {
    // Header row for CIP
    rows.push([
      "CIP Name",
      "Hospital Name",
      "Territory",
      "Department",
      "Designation",
      "Month",
      "Product Name",
      "Quantity",
    ]);

    data.forEach(cip => {
      const allProducts = cip.campignDoctorInners.flatMap(monthObj =>
        monthObj.productDetails
          .filter(p => p.productName && p.quantity > 0)
          .map(product => ({
            month: monthObj.month,
            productName: product.productName,
            quantity: product.quantity,
          }))
      );

      const grandTotalQuantity = allProducts.reduce((sum, p) => sum + p.quantity, 0);

      let cipInfoRendered = false;

      allProducts.forEach(prod => {
        rows.push([
          cipInfoRendered ? "" : cip.cipName,
          cipInfoRendered ? "" : cip.hospitalName,
          cipInfoRendered ? "" : cip.teritory,
          cipInfoRendered ? "" : cip.department,
          cipInfoRendered ? "" : (cip.designation || "N/A"),
          prod.month,
          prod.productName,
          prod.quantity,
        ]);
        cipInfoRendered = true;
      });

      rows.push([
        "", "", "", "", "", "", "Total Quantity:", grandTotalQuantity,
      ]);
    });
  } else if (selectedType.value === "doctor") {
    // Header row for Doctor
    rows.push([
      "Doctor Name",
      "Hospital Name",
      "Clinic Name",
      "Specialization",
      "Month",
      "Product Name",
      "Quantity",
    ]);

    data.forEach(doctor => {
      const allProducts = doctor.campignDoctorInners.flatMap(monthObj =>
        monthObj.productDetails
          .filter(p => p.productName && p.quantity > 0)
          .map(p => ({
            month: monthObj.month,
            productName: p.productName,
            quantity: p.quantity,
          }))
      );

      const grandTotalQuantity = allProducts.reduce((sum, p) => sum + p.quantity, 0);

      let doctorInfoRendered = false;

      if (allProducts.length > 0) {
        allProducts.forEach(prod => {
          rows.push([
            doctorInfoRendered ? "" : doctor.doctorName,
            doctorInfoRendered ? "" : doctor.hospitalName,
            doctorInfoRendered ? "" : (doctor.clinicName || "N/A"),
            doctorInfoRendered ? "" : doctor.specialization,
            prod.month,
            prod.productName,
            prod.quantity,
          ]);
          doctorInfoRendered = true;
        });

        rows.push([
          "", "", "", "", "", "Total Quantity:", grandTotalQuantity,
        ]);
      } else {
        // No products: print just doctor info + "No products"
        rows.push([
          doctor.doctorName,
          doctor.hospitalName,
          doctor.clinicName || "N/A",
          doctor.specialization,
          "", 
          "No products",
          "",
        ]);
      }
    });
  } else {
    alert("No records to export for the selected type.");
    return;
  }

  // Convert rows to CSV string
  const csv = rows
    .map(row =>
      row
        .map(field => {
          const value = field == null ? "" : String(field);
          return /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
        })
        .join(",")
    )
    .join("\n");

  const filename = `${selectedType.value} Campign ${productType ? "Product" : "Gift"}(${selectedUser.name})-${new Date()
    .toISOString()
    .slice(0, 10)}.csv`;
  const csvData = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
  const link = document.createElement("a");
  link.setAttribute("href", csvData);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}



      const handleStartMonth = (value) => {
        setStart(value);
    }   

  return (
    <>
       <Container fluid style={{ minHeight: "80vh" }}>
            <div
                className="glass-body"
                style={{
                    margin: 10,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: 0,
                    backgroundColor: 'transparent'
                }}
            >

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <ul id="breadcrumb">
                        <li><a href="/"><IoHomeOutline
                            style={{ color: "white", fontSize: 20 }}
                        /></a></li>
                        <li><a href="/visit-analysis"><span class="icon icon-beaker"> </span>Reports</a></li>

                        <li><a href="#"><span class="icon icon-double-angle-right"></span>Campign Report</a></li>

                    </ul>

                </div>

            </div>
            <div className="glass-body" style={{ margin: 10 }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "left",
                    }}
                    className="flex-column-mobile"
                >
               <div
                className="d-flex flex-wrap align-items-end gap-3"
                style={{ marginBottom: '20px' }}
                >
                {/* User Select */}
                {Op_per.get().REPORTS_TP_VS_ACHIEVEMENT.USER_DROPDOWN && (
                  <div style={{ minWidth: '250px', maxWidth: '250px' }}>
                    <Form.Group className="mb-1 d-flex align-items-center gap-1">
                      <Form.Label style={{ whiteSpace: 'nowrap', marginBottom: 0 }}>Users</Form.Label>
                      <div style={{ flex: 1 }}>
                        <Select
                          className="selectdoctor"
                          options={options}
                          value={selectedUser}
                          onChange={handleSelectChange}
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: '180px',
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              color: '#ccc',
                            }),
                          }}
                        />
                      </div>
                    </Form.Group>
                  </div>
                )}


                {/* Start Month */}
                <div style={{ minWidth: '250px', maxWidth: '300px' }}>
                  <Form.Group className="mb-1 w-100 d-flex align-items-center gap-1">
                    <Form.Label>From</Form.Label>
                    <input
                      className="form-control"
                      type="month"
                      id="start"
                      name="start"
                      onChange={(e) => handleStartMonth(e.target.value)}
                      value={start}
                    />
                  </Form.Group>
                </div>

                {/* End Month */}
                <div style={{ minWidth: '250px', maxWidth: '250px' }}>
                  <Form.Group className="mb-1 d-flex align-items-center gap-1">
                    <Form.Label>To</Form.Label>
                    <input
                      className="form-control"
                      type="month"
                      id="end"
                      name="end"
                      onChange={(e) => setEnd(e.target.value)}
                      value={end}
                    />
                  </Form.Group>
                </div>

                {/* Type Select */}
                <div style={{ minWidth: '250px', maxWidth: '300px' }}>
                  <Form.Group className="mb-1 w-100 d-flex align-items-center gap-1">
                    <Form.Label>Type</Form.Label>
                    <Select
                      className="selectdoctor"
                      options={typeoptions}
                      value={selectedType}
                      onChange={handleTypeChange}
                      styles={{
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          color: '#ccc'
                        })
                      }}
                    />
                  </Form.Group>
                </div>

                {/* isProduct Select */}
               <div style={{ minWidth: '250px', maxWidth: '300px' }}>
                <Form.Group className="mb-1 w-100 d-flex align-items-end gap-1">
                    <Form.Label style={{width:"300px"}}>Select Product type</Form.Label>
                    <Select
                    className="selectdoctor"
                    options={productTypeOptions}
                    value={productTypeOptions.find(opt => opt.value === productType)} // controlled value
                    onChange={(selectedOption) => setProductType(selectedOption.value)} // update state on change
                    styles={{
                        dropdownIndicator: (provided) => ({
                        ...provided,
                        color: '#ccc'
                        })
                    }}
                    />
                </Form.Group>
                </div>

                {/* Export Button */}
                <div style={{ minWidth: '20px' }}>
                  <Form.Group className="mb-1 w-100 d-flex align-items-center gap-2">
                    <Form.Label>&nbsp;</Form.Label>
                    <Button
                      className="w-100"
                      onClick={() => downloadCSV(data, selectedType, selectedUser)}
                    >
                      <RiFileExcel2Fill size={18} />
                    </Button>
                  </Form.Group>
                </div>
                </div>

                </div>
{pending ? (
  <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', height: '300px' }}>
    <LoadingComponent />
  </div>
) : (
  <div style={{display: "flex", justifyContent: 'start', alignItems: 'start', width: "100", overflowX: "auto", padding: "10px 0" }}>
    {data.length > 0 ? (
      <div className="pt-3 overflow-x-auto">
        <table className="tg" >
          <thead className="bg-gray-200">
            <tr>
              <th rowSpan="3" className="tg-0pky px-2">{selectedType.label}</th>
              <th rowSpan="3" className="tg-0pky px-2">Hospital Name</th>
              {selectedType.value === 'cip' && (
                <React.Fragment>
                <th rowSpan="3" className="tg-0pky px-2">Teritory</th>
                <th rowSpan="3" className="tg-0pky px-2">Department</th>
                <th rowSpan="3" className="tg-0pky px-2">Designation</th>
                </React.Fragment>
              )}
              {selectedType.value === 'doctor' && (
                <React.Fragment>
                <th rowSpan="3" className="tg-0pky px-2">Clinic</th>
                <th rowSpan="3" className="tg-0pky px-2">Specialization</th>
                </React.Fragment>
              )}
              <th rowSpan="3" className="tg-0pky px-2">Month</th>
              <th rowSpan="3" className="tg-0pky px-2">Sample Product</th>
              <th rowSpan="3" className="tg-0pky px-2">Quantity</th>
            </tr>
          </thead>

{selectedType.value === 'cip' ? (
  <tbody>
    {data.map((cip, cipIdx) => {
      // Filter valid products (productName not null and quantity > 0)
      const allProducts = cip.campignDoctorInners.flatMap(monthObj =>
        monthObj.productDetails
          .filter(p => p.productName && p.quantity > 0)
          .map(product => ({
            month: monthObj.month,
            productName: product.productName,
            quantity: product.quantity,
          }))
      );

      const grandTotalQuantity = allProducts.reduce((sum, p) => sum + p.quantity, 0);
      const totalRows = allProducts.length + 1;

      let cipInfoRendered = false;

      return (
        <React.Fragment key={cipIdx}>
          {allProducts.length > 0 ? (
            allProducts.map((prod, prodIdx) => {
              const showCipInfo = !cipInfoRendered && prodIdx === 0;
              if (showCipInfo) cipInfoRendered = true;
              return (
                <tr key={`${cipIdx}-${prodIdx}`}>
                  {showCipInfo && (
                    <>
                      <td rowSpan={totalRows}>{cip.cipName}</td>
                      <td rowSpan={totalRows}>{cip.hospitalName}</td>
                      <td rowSpan={totalRows}>{cip.teritory ? cip.teritory : "N/A"}</td>
                      <td rowSpan={totalRows}>{cip.department ? cip.department : "N/A"}</td>
                      <td rowSpan={totalRows}>{cip.designation || "N/A"}</td>
                    </>
                  )}
                  <td>{prod.month}</td>
                  <td>{prod.productName}</td>
                  <td>{prod.quantity}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td>{cip.cipName}</td>
              <td>{cip.hospitalName}</td>
              <td>{cip.teritory}</td>
              <td>{cip.department}</td>
              <td>{cip.designation || "N/A"}</td>
              <td colSpan={3} style={{ textAlign: 'center', fontStyle: 'italic' }}>
                No products
              </td>
            </tr>
          )}
          {allProducts.length > 0 && (
            <tr key={`${cipIdx}-total`}>
              <td colSpan={2} style={{ fontWeight: 'bold', textAlign: 'right' }}>
                Total Quantity
              </td>
              <td style={{ fontWeight: 'bold' }}>{grandTotalQuantity}</td>
            </tr>
          )}
        </React.Fragment>
      );
    })}
  </tbody>
) : selectedType.value === 'doctor' ? (
  <tbody>
    {data.map((doctor, doctorIdx) => {
      const allProducts = doctor.campignDoctorInners.flatMap(monthObj =>
        monthObj.productDetails
          .filter(p => p.productName && p.quantity > 0)
          .map(p => ({
            month: monthObj.month,
            productName: p.productName,
            quantity: p.quantity,
          }))
      );

      const grandTotalQuantity = allProducts.reduce((sum, p) => sum + p.quantity, 0);
      const totalRows = allProducts.length + 1;

      let doctorInfoRendered = false;

      return (
        <React.Fragment key={doctorIdx}>
          {allProducts.length > 0 ? (
            allProducts.map((prod, prodIdx) => {
              const showDoctorInfo = !doctorInfoRendered && prodIdx === 0;
              if (showDoctorInfo) doctorInfoRendered = true;
              return (
                <tr key={`${doctorIdx}-${prodIdx}`}>
                  {showDoctorInfo && (
                    <>
                      <td rowSpan={totalRows}>{doctor.doctorName}</td>
                      <td rowSpan={totalRows}>{doctor.hospitalName}</td>
                      <td rowSpan={totalRows}>{doctor.clinicName || "N/A"}</td>
                      <td rowSpan={totalRows}>{doctor.specialization}</td>
                    </>
                  )}
                  <td>{prod.month}</td>
                  <td>{prod.productName}</td>
                  <td>{prod.quantity}</td>
                </tr>
              );
            })
          ) : (
            <tr key={`${doctorIdx}-no-data`}>
              <td>{doctor.doctorName}</td>
              <td>{doctor.hospitalName}</td>
              <td>{doctor.clinicName || "N/A"}</td>
              <td>{doctor.specialization}</td>
              <td colSpan={3} style={{ textAlign: "center", fontStyle: "italic" }}>
                No products
              </td>
            </tr>
          )}
          {allProducts.length > 0 && (
            <tr key={`${doctorIdx}-total`}>
              <td colSpan={2} style={{ fontWeight: "bold", textAlign: "right" }}>
                Total Quantity
              </td>
              <td style={{ fontWeight: "bold" }}>{grandTotalQuantity}</td>
            </tr>
          )}
        </React.Fragment>
      );
    })}
  </tbody>
) : (
  <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
    There are no records to display
  </div>
)}



        </table>
      </div>
    ) : (
      <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>There are no records to display</div>
    )}
  </div>
)}

        </div>
      </Container>
    </>
  );
};

export default CampignReport;